let cachedFeatures: Set<string> | null = null

const mergeFromUrl = () => {
  if (!cachedFeatures) {
    const params = new URLSearchParams(window.location.search).getAll('feature')
    cachedFeatures = new Set(params)
  }
}

export const isFeatureTogglesOn = (features: string[]) => {
  mergeFromUrl()
  return features.every((f) => cachedFeatures!.has(f))
}

export const resetToggles = () => {
  cachedFeatures = null
}

mergeFromUrl()
